import Bignumber from '@metrics/big-number/bignumber'
import { Flex, Icon, Typography } from '@nilohealth/core-ui'
import { MdArrowForward } from 'react-icons/md'

import { DashboardBigNumbers, DashboardGroupCardLink } from './dashboard.styles'
import { DashboardGroup } from './dashboard.types'

type DashboardBigNumberGroupProps = {
  mode: 'home' | 'category' | 'indicator'
  group: DashboardGroup
  hideTitle?: boolean
}
const DashboardBigNumberGroup = ({ mode, group, hideTitle = false }:DashboardBigNumberGroupProps) => {
  return (
    <Flex direction="column" gap="xxxsmall">
      <Flex>
        {!hideTitle &&
          (group.dashboardReferralSlug ? (
            <DashboardGroupCardLink href={group.dashboardReferralSlug}>
              <Typography type="paragraphSmall" weight="semibold">
                {group.name}
              </Typography>

              <Icon icon={MdArrowForward} size="medium" />
            </DashboardGroupCardLink>
          ) : (
            <Typography type="subtitleSmall" weight="semibold">
              {group.name}
            </Typography>
          ))}
      </Flex>

      <DashboardBigNumbers>
        {group.bigNumbers.map(item => (
          <Bignumber key={item.slug} mode={mode} metricId={item.slug} url={item.dashboardReferralSlug} />
        ))}
      </DashboardBigNumbers>
    </Flex>
  )
}

export default DashboardBigNumberGroup
